import { createFileRoute, notFound } from '@tanstack/react-router'
import { HTTPError } from 'ky'

import PendingComponent from '@/components/pending-component'
import { synopticQuery } from '@/queries/synoptic.query'

export const Route = createFileRoute('/_dashboard/admin/synoptics/$id/')({
  parseParams(params) {
    const id = Number.parseInt(params.id, 10)

    if (Number.isNaN(id)) {
      throw notFound()
    }

    return { id }
  },
  async loader({ context, params }) {
    try {
      return await context.queryClient.ensureQueryData(synopticQuery(params.id))
    } catch (error) {
      if (error instanceof HTTPError && !error.response.ok) {
        throw notFound()
      }

      throw error
    }
  },
  pendingComponent: PendingComponent,
})
